import React, { useId } from 'react';

import Card from '@amzn/meridian/card';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import EmDash from 'src/components/shared/emdash';

export interface PlacementMetricCardProps {
  label: string;
  /** Undefined while there is no data, which renders "—". */
  count?: number;
  /** Leave undefined while loading to show "—", or pass null to hide the line entirely. */
  subheader?: string | null;
}

/** One card in the Approved Active Placements band. */
const PlacementMetricCard = ({ label, count, subheader }: PlacementMetricCardProps) => {
  const labelId = useId();

  return (
    <Card spacingInset="400">
      <Column spacing="100" role="group" aria-labelledby={labelId}>
        <Text id={labelId} type="h100" color="secondary">
          {label}
        </Text>
        <Text type="h600">{count === undefined ? <EmDash /> : count}</Text>
        {subheader !== null && (
          <Text type="b200" color="secondary">
            {subheader === undefined ? <EmDash /> : subheader}
          </Text>
        )}
      </Column>
    </Card>
  );
};

export default PlacementMetricCard;
